<!-- 用户权限管理 -->
<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh">刷新</button>
    </div>
    
    <!-- 角色管理内容区 -->
    <div v-if="activeTab==='角色管理'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <!-- <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="searchForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="searchForm.endDate" placeholder="" />
            </div> -->
            <div class="form-item">
              <label>用户姓名：</label>
              <input class="form-input"  v-model="searchForm.userName" placeholder="请输入姓名"/>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onClear">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>用户姓名</th>
                <th>所属单位</th>
                <th>电话</th>
                <th>超级管理员</th>
                <th>管理员</th>
                <th>普通用户</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="8" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="roleList.length === 0">
                <td colspan="8" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in roleList" :key="item.userId">
                  <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.orgName }}</td>
                  <td>{{ item.mobile }}</td>
                  <td>
                    <span v-if="item.isSuperAdmin" class="status-badge status-active">是</span>
                    <span v-else class="status-badge status-inactive">否</span>
                  </td>
                  <td>
                    <span v-if="item.isAdmin" class="status-badge status-active">是</span>
                    <span v-else class="status-badge status-inactive">否</span>
                  </td>
                  <td>
                    <span v-if="item.isUser" class="status-badge status-active">是</span>
                    <span v-else class="status-badge status-inactive">否</span>
                  </td>
                  <td>
                    <button class="btn btn-edit" @click="editRole(item)">编辑</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        
        <!-- 分页 -->
        <div class="pagination" v-if="roleTotal > 0">
          <button class="page-btn" :disabled="page===1" @click="changePage(1)">«</button>
          <button class="page-btn" :disabled="page===1" @click="changePage(page-1)">&lt;</button>
          <!-- <span v-for="p in displayPages" :key="p">
            <button class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
          </span> -->
          <span v-for="p in displayPages" :key="p">
            <button v-if="p !== '...'" class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
          <span v-else class="page-ellipsis">...</span>
          </span>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(page+1)">&gt;</button>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(totalPages)">»</button>
          <div class="page-jump">                  
            <input type="text" v-model.number="pageInput" style="width:50px;"/>
            <button class="jump-btn" @click="jumpPage">跳转</button>
            <span style="margin-left:10px;">共{{roleTotal}}条数据</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 操作日志内容区 -->
    <div v-else-if="activeTab==='操作日志'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="searchOperateLogForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="searchOperateLogForm.endDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>导出类型：</label>
              <select class="form-input" v-model="searchOperateLogForm.exportFormat">
                <option value="">请选择</option>
                <option value="EXCEL">EXCEL</option>
                <option value="CSV">CSV</option>
              </select>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onOperateLogSearch">搜索</button>
            <button type="button" class="search-btn-green" @click="exportOperateLog">导出操作日志</button>
            <button type="button" class="clear-btn" @click="onOperateLogClear">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>用户姓名</th>
                <th>权限</th>
                <th>电话</th>
                <!-- <th>操作类型</th> -->
                <th>登录时间</th>
                <th>操作时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="operateLogList.length === 0">
                <td colspan="6" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in operateLogList" :key="item.logId">
                  <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td>{{ item.userName }}</td>
                  <td>
                    <span class="permission-badge" :class="getPermissionClass(item.roleName)">
                      {{ item.roleName }}
                    </span>
                  </td>
                  <td>{{ item.mobile }}</td>
                  <!-- <td>
                    <span class="operate-badge" :class="getOperateTypeClass(item.operationTypeName)">
                      {{ item.operationTypeName }}
                    </span>
                  </td> -->
                  <td>{{ item.loginTime }}</td>
                  <td>{{ item.operationTime }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination" v-if="operateLogTotal > 0">
          <button class="page-btn" :disabled="page===1" @click="changePage(1)">«</button>
          <button class="page-btn" :disabled="page===1" @click="changePage(page-1)">&lt;</button>
          <span v-for="p in displayPages" :key="p">
            <button class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(page+1)">&gt;</button>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(totalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="pageInput" style="width:50px;"/>
            <button class="jump-btn" @click="jumpPage">跳转</button>
            <span style="margin-left:10px;">共{{operateLogTotal}}条数据</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 权限变更记录内容区 -->
    <div v-else-if="activeTab==='权限变更记录'">
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="searchPermissionChangeLogsForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="searchPermissionChangeLogsForm.endDate" placeholder="" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="onPermissionChangeLogsSearch">搜索</button>
            <button type="button" class="clear-btn" @click="onPermissionChangeLogsClear">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>用户姓名</th>
                <th>当前权限</th>
                <th>变更前权限</th>
                <th>注册时间</th>
                <th>变更时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="6" style="text-align:center;color:#bbb;">数据加载..</td>
              </tr>
              <tr v-else-if="permissionChangeList.length === 0">
                <td colspan="6" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
              <template v-else>
                <tr v-for="(item, index) in permissionChangeList" :key="item.changeLogId">
                  <td>{{ (page - 1) * pageSize + index + 1 }}</td>
                  <td>{{ item.userName }}</td>
                  <td>
                    <span class="permission-badge" :class="getPermissionClass(item.currentRoleName)">
                      {{ item.currentRoleName }}
                    </span>
                  </td>
                  <td>
                    <span class="permission-badge permission-old" :class="getPermissionClass(item.previousRoleName)">
                      {{ item.previousRoleName }}
                    </span>
                  </td>
                  <td>{{ item.registerTime }}</td>
                  <td>{{ item.changeTime }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        
        <!-- 分页 -->
        <div class="pagination" v-if="permissionChangeTotal > 0">
          <button class="page-btn" :disabled="page===1" @click="changePage(1)">«</button>
          <button class="page-btn" :disabled="page===1" @click="changePage(page-1)">&lt;</button>
          <span v-for="p in displayPages" :key="p">
            <button class="page-btn" :class="{active:page===p}" @click="changePage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(page+1)">&gt;</button>
          <button class="page-btn" :disabled="page===totalPages" @click="changePage(totalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="pageInput" style="width:50px;"/>
            <button class="jump-btn" @click="jumpPage">跳转</button>
            <span style="margin-left:10px;">共{{permissionChangeTotal}}条数据</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑角色弹窗 -->
    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>编辑角色 - {{ editingUser.userName }}</h3>
          <button class="modal-close" @click="closeEditModal">×</button>
        </div>
        <div class="modal-body">
          <div class="role-edit-form">
            <div class="role-item">
              <label class="role-label">
                <input 
                  type="radio" 
                  v-model="editForm.selectedRole"
                  value="superAdmin"
                >
                <span class="radio-text">超级管理员</span>
              </label>
              <span class="role-desc">拥有小程序超时、解封处理及WEB端所有权限</span>
            </div>
            
            <div class="role-item">
              <label class="role-label">
                <input 
                  type="radio" 
                  v-model="editForm.selectedRole"
                  value="admin"
                >
                <span class="radio-text">管理员</span>
              </label>
              <span class="role-desc">拥有小程序洗衣、超时处理、投诉权限</span>
            </div>
            
            <div class="role-item">
              <label class="role-label">
                <input 
                  type="radio" 
                  v-model="editForm.selectedRole"
                  value="normalUser"
                >
                <span class="radio-text">普通用户</span>
              </label>
              <span class="role-desc">小程序基础洗衣使用权限</span>
            </div>

            <!-- <div class="role-item"> 
              <label class="role-label">理由：</label>
              <input type="text" v-model="editForm.reason">  
            </div> -->
            
            <div class="role-rules">
              <p><strong>权限规则：</strong></p>
              <ul>
                <li>每个用户只能拥有一个角色</li>
                <li>超级管理员拥有小程序和WEB端权限</li>
                <li>管理员拥有小程序权限</li>
                <li>普通用户拥有小程序权限</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-cancel" @click="closeEditModal">取消</button>
          <button class="btn btn-confirm" @click="saveRole" :disabled="!editForm.selectedRole">保存</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { listRoles, 
  updateUserRole, 
  listOperationLogs,
  listPermissionChangeLogs, 
  exportOperationLog } from '@/api/laundry.js'; 

// 导入工具函数
import { downloadFile } from '@/api/download';

// 操作日志：操作类型枚举映射：接口值 ↔ 前端显示值
const operateTypeMap = {
  API_TO_VIEW: {
    LOGIN_SYSTEM: '登录系统',
    VIEW_REPORT: '查看报表',
    MODIFY_CONFIG: '修改配置',
    EXPORT_DATA: '导出数据',
    ASSIGN_PERMISSION: '权限分配',
    DATA_QUERY: '数据查询',
    USER_MANAGE: '用户管理',
    OTHER: '其他'
  },
  VIEW_TO_API: {
    '登录系统': 'LOGIN_SYSTEM',
    '查看报表': 'VIEW_REPORT',
    '修改配置': 'MODIFY_CONFIG',
    '导出数据': 'EXPORT_DATA',
    '权限分配': 'ASSIGN_PERMISSION',
    '数据查询': 'DATA_QUERY',
    '用户管理': 'USER_MANAGE',
    '其他': 'OTHER'
  }
};

// 操作日志：用户角色枚举映射 接口值 ↔ 前端显示值
const roleMap = {
  SUPER_ADMIN: '超级管理员',
  ADMIN: '管理员',
  USER: '普通用户',
  '超级管理员': '超级管理员',
  '管理员': '管理员',
  '普通用户': '普通用户'
};

export default {
  name: 'LaundryPermissionManagement',
  data() {
    return {
      // 标签页配置
      tabs: [
        { label: '角色管理' },
        // { label: '操作日志' },
        // { label: '权限变更记录' }
      ],
      activeTab: '角色管理',
      loading: false,
      // 分页参数
      page: 1,
      pageSize: 10,
      pageInput: '',

      // 角色管理搜索条件
      searchForm: {
        userName: '',
        startDate: '',
        endDate: ''
      },
      // 操作日志搜索条件
      searchOperateLogForm: {
        startDate: '',
        endDate: '',
        exportFormat: '' // 导出格式：EXCEL、CSV
      },
      // 权限变更记录搜索条件
      searchPermissionChangeLogsForm: {
        startDate: '',
        endDate: ''
      },

      // 角色管理返回数据存储
      roleList: [],
      roleTotal: 0,

      // 操作日志返回数据存储
      operateLogList: [],
      operateLogTotal: 0,

      // 权限变更记录返回数据存储
      permissionChangeList: [],
      permissionChangeTotal: 0,

      // 编辑相关
      showEditModal: false,
      editingUser: null,
      editForm: {
        selectedRole: '' 
      },
    };
  },

  computed: {
    // 总页数（根据当前标签页的总条数计算）
    totalPages() {
      let total = 0;
      switch (this.activeTab) {
        case '角色管理':
          total = this.roleTotal;
          break;
        case '操作日志':
          total = this.operateLogTotal;
          break;
        case '权限变更记录':
          total = this.permissionChangeTotal;
          break;
      }
      return Math.ceil(total / this.pageSize) || 1;
    },
    // 显示的页码
    displayPages() {
      const total = this.totalPages;
      const current = this.page;
      const maxDisplay = 7; // 最多显示7个页码按钮（包括省略号）
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      const pages = [];
      
      if (current <= 4) {
        // 当前页靠近开头
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      } else if (current >= total - 3) {
        // 当前页靠近结尾
        pages.push(1);
        pages.push('...');
        for (let i = total - 4; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // 当前页在中间
        pages.push(1);
        pages.push('...');
        for (let i = current - 1; i <= current + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      }
      
      return pages;
    },
    // displayPages() {
    //   const total = this.totalPages;
    //   const current = this.page;
    //   const maxDisplay = 5;
    //   if (total <= maxDisplay) {
    //     return Array.from({ length: total }, (_, i) => i + 1);
    //   }
    //   let start = Math.max(1, current - Math.floor(maxDisplay / 2));
    //   let end = Math.min(total, start + maxDisplay - 1);
    //   if (end - start + 1 < maxDisplay) {
    //     start = Math.max(1, end - maxDisplay + 1);
    //   }
    //   return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    // }
  },

  watch: {
    // 切换标签页时重置页码并加载数据
    activeTab(newTab) {
      this.page = 1;
      this.loadTabData(newTab);
    }
  },

  created() {
    // 页面初始化时加载当前标签页数据
    this.loadTabData(this.activeTab);
  },

  methods: {
    // ---------------------- 公共方法 ----------------------
    // 日期格式转换：yyyy-MM-dd → yyyy/MM/dd（适配接口入参要求）
    formatDate(date) {
      return date ? date.replace(/-/g, '/') : '';
    },
    
    // 加载当前标签页数据
    async loadTabData(tab) {
      this.loading = true;
      try {
        switch (tab) {
          case '角色管理':
            this.loadHandleRole();
            break;
          case '操作日志':
            this.loadOperateLog();
            break;
          case '权限变更记录':
            this.loadPermissionChangeLogs();
            break;
        }
      } catch (error) {
        console.error(`加载${tab}数据失败：`, error);
        this.showMessage(`加载${tab}数据失败`, 'error');
        // 清空数据
        this.clearTabData(tab);
      } finally {
        this.loading = false;
      }
    },
    
    // 清空标签页数据
    clearTabData(tab) {
      switch (tab) {
        case '角色管理':
          this.roleList = [];
          this.roleTotal = 0;
          break;
        case '操作日志':
          this.operateLogList = [];
          this.operateLogTotal = 0;
          break;
        case '权限变更记录':
          this.permissionChangeList = [];
          this.permissionChangeTotal = 0;
          break;
      }
    },
    
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab.label;
      this.page = 1;
      // 不自动清空搜索条件，保留各标签页的筛选状态
    },
    
    // 刷新数据
    onRefresh() {
      this.loading = true;
      try {
        this.loadTabData(this.activeTab);
        this.showMessage('数据刷新成功', 'success');
      } catch (error) {
        this.showMessage('数据刷新失败', 'error');
      } finally {
        this.loading = false;
      }
    },

    // ---------------------- 接口管理方法 ----------------------
    // 7.1 加载角色管理数据
    async loadHandleRole() {
      const params = {
        ...this.searchForm,// 请求参数
        startDate: this.formatDate(this.searchForm.startDate),
        endDate: this.formatDate(this.searchForm.endDate),
        pageNo: this.page,
        pageSize: this.pageSize
      };
      const respose = await listRoles(params);
      const res = respose.data;
      if (res.code === 0 && res.data) {
        const { list, total } = res.data;
        //数据映射到前端字段
        this.roleList = this.mapRoleList(list);
        this.roleTotal = total || 0;
      } else {
        this.roleList = [];
        this.roleTotal = 0;
        this.showMessage(res?.message || '获取角色数据失败', 'error');
      }
    },

    // 7.2 编辑保存用户权限
    async saveRole() {
      if (!this.editForm.selectedRole) {
        this.showMessage('请选择一个角色！', 'error');
        return;
      }
      
      try {
        const roleMap = {
          superAdmin: 'SUPER_ADMIN',
          admin: 'ADMIN',
          normalUser: 'USER'
        };
        const reqData = {
          userId: this.editingUser.userId,
          role: roleMap[this.editForm.selectedRole],
          reason: this.editForm.reason
        };
        
        const respose = await updateUserRole(reqData);
        const res = respose.data;

        if (res.data && res.code === 0) {
          this.showMessage('角色更新成功！', 'success');
          this.closeEditModal();
          //1s后刷新数据
          setTimeout(() => {
            this.loadTabData('角色管理');
          }, 1000);
          
        } else {
          this.showMessage(res?.message || '角色更新失败', 'error');
        }
      } catch (error) {
        console.error('保存角色失败：', error);
        this.showMessage('保存失败，请检查网络', 'error');
      } finally {
        this.loading = false;
      }
    },

    // 7.3 加载操作日志数据
    async loadOperateLog() {
      const params = {
        ...this.searchOperateLogForm,
        startDate: this.formatDate(this.searchOperateLogForm.startDate),
        endDate: this.formatDate(this.searchOperateLogForm.endDate),
        pageNo: this.page,
        pageSize: this.pageSize
      };

      const respose = await listOperationLogs(params);
      const res = respose.data;    
      if (res.code === 0 && res.data) {
        const { list, total } = res.data;
        this.operateLogList = this.mapLogList(list);
        this.operateLogTotal = total || 0;
      } else {
        this.operateLogList = [];
        this.operateLogTotal = 0;
        this.showMessage(res?.message || '获取操作日志失败', 'error');
      }
    },

    // 7.4 加载权限变更记录数据
    async loadPermissionChangeLogs() {
      const params = {
        ...this.searchPermissionChangeLogsForm,
        startDate: this.formatDate(this.searchPermissionChangeLogsForm.startDate),
        endDate: this.formatDate(this.searchPermissionChangeLogsForm.endDate),
        pageNo: this.page,
        pageSize: this.pageSize
      };
      const respose = await listPermissionChangeLogs(params);
      const res = respose.data;
       if (res.code === 0 && res.data) {
        const { list, total } = res.data;
        this.permissionChangeList = this.mapPermissionChangeLogs(list);
        this.permissionChangeTotal = total || 0;
      } else {
        this.permissionChangeList = [];
        this.permissionChangeTotal = 0;
        this.showMessage(res?.message || '获取权限变更记录失败', 'error');
      }
    },

    // 7.5 导出操作日志
    async exportOperateLog() {
      try {
        const params = {
          ...this.searchOperateLogForm,
          startDate: this.formatDate(this.searchOperateLogForm.startDate),
          endDate: this.formatDate(this.searchOperateLogForm.endDate),
          exportFormat: this.searchOperateLogForm.exportFormat
        };
        
        const respose = await exportOperationLog(params);
        const res = respose.data;
        if (res.code === 0 && res.data) {
          this.showMessage('导出成功，即将下载！', 'success');
          // window.open(res.data.fileUrl, '_blank');
          downloadFile(res.data.fileUrl, res.data.fileName, res.data.expiresAt);
        } else {
          this.showMessage(res?.message || '导出失败', 'error');
        }
      } catch (error) {
        console.error('导出操作日志失败：', error);
        this.showMessage('导出失败，请检查网络', 'error');
      } finally {
        this.loading = false;
      }
    },

    // ---------------------- 角色管理方法 ----------------------
    // 映射用户列表：接口字段 → 前端字段
    mapRoleList(list) {
      return list.map(item => ({
        userId: item.userId,
        userName: item.userName,
        mobile: item.mobile,
        orgName: item.orgName,
        isSuperAdmin: item.isSuperAdmin,
        isAdmin: item.isAdmin,
        isUser: item.isUser
      }));
    },

    // 角色管理搜索
    onSearch() {
      this.page = 1;
      this.loadTabData('角色管理');
      // 验证日期格式是否正确
      // if (this.validateDate(this.searchForm.startDate, this.searchForm.endDate)) {
      //   this.loadTabData('角色管理');
      // } else {
      //   this.searchForm = { startDate: '', endDate: '' };
      // }
    },
    
    // 角色管理清空
    onClear() {
      this.searchForm = { userName: '', startDate: '', endDate: '' };
      this.page = 1;
      this.loadTabData('角色管理');
    },
    
    // 编辑角色弹窗打开
    editRole(user) {
      this.editingUser = { ...user };
      // 映射接口返回的权限状态到单选框
      if (user.isSuperAdmin) {
        this.editForm.selectedRole = 'superAdmin';
      } else if (user.isAdmin) {
        this.editForm.selectedRole = 'admin';
      } else if (user.isUser) {
        this.editForm.selectedRole = 'normalUser';
      } else {
        this.editForm.selectedRole = '';
      }
      this.showEditModal = true;
    },
    
    // 关闭编辑弹窗
    closeEditModal() {
      this.showEditModal = false;
      this.editingUser = null;
      this.editForm = { selectedRole: '' };
    },
    
    // ---------------------- 操作日志方法 ----------------------
    // 映射用户列表：接口字段 → 前端字段
    mapLogList(list) {
      return list.map(item => ({
        userName: item.userName,
        roleName: roleMap[item.roleName],
        mobile: item.mobile,
        operationTypeName: operateTypeMap.API_TO_VIEW[item.operationType],
        loginTime: item.loginTime,
        operationTime: item.operationTime
      }));
    },

    // 操作日志搜索
    onOperateLogSearch() {
      this.page = 1;
      if (this.validateDate(this.searchOperateLogForm.startDate, this.searchOperateLogForm.endDate)) {
        this.loadTabData('操作日志');
      } else {
        this.searchOperateLogForm = { startDate: '', endDate: '', exportFormat: '' };
      }
    },
    
    // 操作日志清空
    onOperateLogClear() {
      this.searchOperateLogForm = { startDate: '', endDate: '', exportFormat: '' };
      this.page = 1;
      this.loadTabData('操作日志');
    },
    
    // ---------------------- 权限变更记录方法 ----------------------
    // 权限变更记录映射：接口字段 → 前端字段
    mapPermissionChangeLogs(list) {
      return list.map(item => ({
        changeLogId: item.changeLogId,
        userName: item.userName,
        currentRoleName: item.currentRoleName,
        previousRoleName: item.previousRoleName,
        registerTime: item.registerTime,
        changeTime: item.changeTime
      }));
    },

    // 权限变更记录搜索
    onPermissionChangeLogsSearch() {
      this.page = 1;
      // 验证日期格式是否正确
      if ( this.validateDate(this.searchPermissionChangeLogsForm.startDate, this.searchPermissionChangeLogsForm.endDate))
        {
          this.loadTabData('权限变更记录');
        }
      else {
        this.searchPermissionChangeLogsForm = { startDate: '', endDate: '' };
      }
    },
    
    // 权限变更记录清空
    onPermissionChangeLogsClear() {
      this.searchPermissionChangeLogsForm = { startDate: '', endDate: '' };
      this.page = 1;
      this.loadTabData('权限变更记录');
    },
    
    // ---------------------- 分页方法 ----------------------
    // 切换页码
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.page = page;
        this.loadTabData(this.activeTab);
      }
    },
    
    // 页码跳转
    jumpPage() {
      const p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.loadTabData(this.activeTab);
      }
      this.pageInput = '';
    },
    
    // ---------------------- 工具方法 ----------------------
    // 获取操作类型样式
    getOperateTypeClass(operateTypeName) {
      const typeMap = {
        '登录系统': 'operate-login',
        '查看报表': 'operate-view',
        '修改配置': 'operate-edit',
        '导出数据': 'operate-export',
        '权限分配': 'operate-permission',
        '数据查询': 'operate-query',
        '用户管理': 'operate-user',
        '其他': 'operate-default'
      };
      return typeMap[operateTypeName];
    },

    // 获取权限样式
    getPermissionClass(roleName) {
      const permissionMap = {
        '超级管理员': 'permission-super',
        '管理员': 'permission-admin',
        '普通用户': 'permission-normal'
      };
      return permissionMap[roleName];
    },
    
    // 消息提示
    showMessage(message, type = 'info') {
      const messages = {
        success: `✅ ${message}`,
        error: `❌ ${message}`,
        warning: `⚠️ ${message}`,
        info: `ℹ️ ${message}`
      };
      alert(messages[type] || message);
    },

    // 判断开始日期是否小于结束日期, 且开始日期和结束日期是否在365天之内
    validateDate(startDate, endDate, maxDays = 365) {
      if (!startDate || !endDate) {
        this.showMessage('请选择开始日期和结束日期！', 'error');
        return true;
      }
      if (startDate > endDate) {
        this.showMessage('开始日期不能大于结束日期！', 'error');
        return false;
      }
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffDays = Math.round((end - start) / (24 * 3600 * 1000));
      if (diffDays > maxDays) {
        this.showMessage(`日期范围不能超过${maxDays}天！`, 'error');
        return false;
      }
      return true;
    }
    
  }
}
</script>

<style scoped>

.btn {
  padding: 4px 8px;
  margin: 0 5px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: opacity 0.3s;
}

.btn-edit {
  background-color: #1890ff;
  color: white;
}

.btn-delete {
  background-color: #f44336;
  color: white;
}

.btn:hover {
  opacity: 0.8;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.modal-close:hover {
  color: #666;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.role-edit-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.role-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fafafa;
  transition: all 0.3s;
}

.role-item:hover {
  border-color: #1890ff;
  background: #f0f9ff;
}

.role-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.role-label input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.radio-text {
  font-weight: bold;
  color: #333;
  cursor: pointer;
}

.role-desc {
  color: #666;
  font-size: 14px;
}

.role-rules {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #4caf50;
}

.role-rules p {
  margin: 0 0 10px 0;
  color: #333;
}

.role-rules ul {
  margin: 0;
  padding-left: 20px;
  color: #666;
}

.role-rules li {
  margin-bottom: 5px;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-confirm {
  background: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-confirm:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.btn-cancel:hover {
  background: #e8e8e8;
}

.btn-confirm:not(:disabled):hover {
  background: #45a049;
}

/* 操作类型 */
.operate-login {
  background: #52c41a;
}
.operate-view {
  background: #faad14;
}
.operate-edit {
  background: #f5222d;
}
.operate-export {
  background: #1890ff;
}
.operate-permission {
  background: #edf109 ;
}
.operate-query {
  background: #87d068;
}
.operate-user {
  background: #13c2c2;
}
/* .operate-default {
  background: #9e9e9e;
} */

/* 权限 */
.permission-super {
  background: #f5222d;
}
.permission-admin {
  background: #faad14;
}
.permission-normal {
  background: #52c41a;
}
/* .permission-default {
  background: #9e9e9e;
}  */
</style>